import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

// Collapsible is a wrapper component, no visual styling needed
// Uses Radix UI primitives directly

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
